/** Formats stored digits without converting historical money to binary floating point. */
export function formatSourceDecimal(value: string, locale: string): string {
  const [whole = '0', fraction] = value.split('.');
  const integer = BigInt(whole);
  const negativeZero = whole.startsWith('-') && integer === 0n;
  const formatted = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(
    negativeZero ? -0 : integer,
  );
  if (fraction === undefined) return formatted;
  const separator =
    new Intl.NumberFormat(locale).formatToParts(1.1).find((part) => part.type === 'decimal')
      ?.value ?? '.';
  return `${formatted}${separator}${fraction}`;
}
